import type { IconData } from '@stacksjs/iconify-core'

export const gift: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M44.547 40.027c-.233 2.417-2.11 4.209-4.53 4.411c-3.208.27-8.441.562-16.017.562s-12.81-.293-16.017-.562c-2.42-.202-4.297-1.994-4.53-4.41C3.219 37.603 3 33.997 3 29s.22-8.604.453-11.027c.233-2.417 2.11-4.209 4.53-4.411C11.191 13.292 16.424 13 24 13s12.81.293 16.017.562c2.42.202 4.297 1.994 4.53 4.41c.234 2.424.453 6.03.453 11.028c0 4.997-.22 8.604-.453 11.027M24 13v32M3 29h42\"/><path d=\"M24 13c0-3-4-10-10-10c-3.5 0-6 2.686-6 6c0 1.682.692 3.203 1.808 4.292M24 13c0-3 4-10 10-10c3.5 0 6 2.686 6 6a5.98 5.98 0 0 1-1.808 4.292\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default gift
